import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "Puis-je réserver sans créer de compte ?", a: "Oui, le checkout invité est disponible. Renseignez votre email et vos informations de conducteur, vous recevrez la confirmation par email." },
  { q: "Comment fonctionne la caution ?", a: "Une empreinte bancaire (caution) définie par chaque loueur est prise au comptoir lors du retrait du véhicule. Elle est distincte du montant de la location." },
  { q: "Puis-je annuler ma réservation ?", a: "L'annulation est gratuite jusqu'à 24h avant le départ, avec remboursement automatique via Stripe." },
  { q: "Ai-je besoin de mon permis de conduire ?", a: "Oui, le permis de conduire est obligatoire. Vous pouvez le téléverser lors de la réservation ; il sera vérifié par le loueur au retrait." },
  { q: "Dans quelles îles puis-je louer ?", a: "Actuellement en Martinique, Guadeloupe, Saint-Martin et Sint Maarten. D'autres destinations arriveront bientôt." },
  { q: "Comment devenir loueur partenaire ?", a: "Créez un compte loueur, complétez la vérification d'identité Stripe Connect (KYC), puis publiez jusqu'à 25 véhicules gratuitement." },
];

export default function FAQ() {
  const { t } = useTranslation();
  return (
    <div className="section-sand min-h-screen py-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="font-heading font-extrabold text-4xl text-ink text-center mb-10">{t("nav.faq")}</h1>
        <div className="bg-white rounded-2xl shadow-card border border-border p-4 sm:p-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-heading font-bold text-ink text-left hover:text-canard">{f.q}</AccordionTrigger>
                <AccordionContent className="text-muted2 font-body">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
